import { z } from 'zod';
/** `GET /health` — the liveness + readiness answer the API returns and the web app reads. */
export const healthSchema = z.object({
    status: z.enum(['ok', 'degraded']),
    version: z.string(),
    checks: z.object({
        db: z.enum(['ok', 'fail']),
        redis: z.enum(['ok', 'fail']),
    }),
});
//# sourceMappingURL=health.js.map